import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { useAuth } from "../context/AuthContext";
import AuthShell from "../components/public/AuthShell";

const ResendConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleLogout } = useAuth();
  const [email, setEmail] = useState(location.state?.email || "");
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [showLoginOption, setShowLoginOption] = useState(false);

  useEffect(() => {
    if (location.state?.email) setEmail(location.state.email);
  }, [location.state]);

  const handleResendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatusMessage("");
    setIsError(false);
    setShowLoginOption(false);

    try {
      const response = await axiosInstance.post("/auth/resend-confirmation", { email: email.trim() });
      if (response.status === 200) {
        setStatusMessage(response.data.message || "Confirmation email sent. Check your inbox.");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An error occurred. Please try again.";
      setStatusMessage(errorMessage);
      setIsError(true);
      // If the account is already confirmed, offer sign in instead
      if (errorMessage === "Email is already confirmed.") setShowLoginOption(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Clears any stale session, then goes to the sign-in page
  const handleLoginClick = () => {
    if (typeof handleLogout === "function") handleLogout();
    navigate("/login", { replace: true });
  };

  return (
    <AuthShell title="Resend confirmation email" subtitle="Enter your email and we'll send a new confirmation link.">
      {statusMessage && (
        <div className={`auth-alert ${isError ? "is-error" : "is-success"}`} role={isError ? "alert" : "status"}>
          {statusMessage}
        </div>
      )}

      {showLoginOption ? (
        <button type="button" onClick={handleLoginClick} className="auth-btn auth-btn--block">
          Go to sign in
        </button>
      ) : (
        <form onSubmit={handleResendEmail} noValidate>
          <div className="auth-field">
            <label htmlFor="rc-email">Email</label>
            <input
              id="rc-email"
              type="email"
              className="auth-input"
              placeholder="you@yourhotel.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              autoComplete="email"
              inputMode="email"
            />
          </div>
          <button type="submit" disabled={isLoading || !email.trim()} className="auth-btn auth-btn--block">
            {isLoading ? "Sending..." : "Send confirmation email"}
          </button>
        </form>
      )}

      <p className="auth-links">
        Already confirmed?{" "}
        <button type="button" className="auth-linkbtn" onClick={handleLoginClick}>
          Sign in
        </button>
        {" · "}
        <Link to="/">Home</Link>
      </p>
    </AuthShell>
  );
};

export default ResendConfirmationPage;
